import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-5" }
const _hoisted_2 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "btnradio3"
}, "nie uwzględniaj ciepła odpadowego", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "btnradio2"
}, "uwzględnij ciepło odpadowe", -1)

import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltrRodzaj',
  setup(__props) {

const store = useStore();

const setMinersWithHeat = function (type: boolean) {
  store.commit("miners/setMinersType", type);
  store.commit("miners/setMinersProfits");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "radio",
        class: "btn-check",
        name: "btnradio",
        id: "btnradio3",
        autocomplete: "off",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setMinersWithHeat(false))),
        checked: ""
      }),
      _hoisted_3,
      _createElementVNode("input", {
        type: "radio",
        class: "btn-check",
        name: "btnradio",
        id: "btnradio2",
        autocomplete: "off",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (setMinersWithHeat(true)))
      }),
      _hoisted_4
    ])
  ]))
}
}

})